// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Loading from "../Data.Loading/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Restaumatic_Form_Errors from "../Restaumatic.Form.Errors/index.js";
import * as Restaumatic_Form_Totality from "../Restaumatic.Form.Totality/index.js";
import * as Restaumatic_Form_Value from "../Restaumatic.Form.Value/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var genericShowArgsProduct = /* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Loading.showLoadingStatus));
var genericShowArgsProduct1 = /* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Form_Errors.showFormErrors));
var ResultIsSymbol = {
    reflectSymbol: function () {
        return "Result";
    }
};
var map = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_Value.functorValue);
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Loading.eqLoadingStatus);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Form_Errors.eqFormErrors);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Loading.semigroupLoadingStatus);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Restaumatic_Form_Errors.semigroupFormErrors);
var apply = /* #__PURE__ */ Control_Apply.apply(Restaumatic_Form_Value.applyValue);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Data_Loading.monoidLoadingStatus);
var mempty1 = /* #__PURE__ */ Data_Monoid.mempty(Restaumatic_Form_Errors.monoidFormErrors);
var pure = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_Value.applicativeValue);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Data_Validation_Semigroup.applicativeV(Restaumatic_Form_Errors.semigroupFormErrors));
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "fieldLabel";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "fieldName";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "internal";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "message";
    }
})(Data_Show.showString))(Data_Show.showBoolean))(/* #__PURE__ */ Data_Maybe.showMaybe(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString))))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString))))));
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_Map_Internal.foldableMap);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var pure2 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Data_Validation_Semigroup.applicativeV(/* #__PURE__ */ Data_Loading.semigroupLoading(Restaumatic_Form_Errors.semigroupFormErrors)));
var pure3 = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var not = /* #__PURE__ */ Data_HeytingAlgebra.not(/* #__PURE__ */ Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean));
var Result = /* #__PURE__ */ (function () {
    function Result(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    Result.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new Result(value0, value1, value2);
            };
        };
    };
    return Result;
})();
var genericResult_ = {
    to: function (x) {
        return new Result(x.value0, x.value1.value0, x.value1.value1);
    },
    from: function (x) {
        return new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, x.value2));
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(genericResult_);
var showResult = function (dictShow) {
    return {
        show: genericShow(Data_Show_Generic.genericShowConstructor(genericShowArgsProduct(genericShowArgsProduct1(Data_Show_Generic.genericShowArgsArgument(Restaumatic_Form_Value.showValue(dictShow)))))(ResultIsSymbol))
    };
};
var functorResult = {
    map: function (f) {
        return function (m) {
            return new Result(m.value0, m.value1, map(f)(m.value2));
        };
    }
};
var map1 = /* #__PURE__ */ Data_Functor.map(functorResult);
var hasFieldResultResult = function (dictHasField) {
    var getField = Data_Record.getField(dictHasField);
    return {
        getField: function (label) {
            return map1(getField(label));
        }
    };
};
var eqResult = function (dictEq) {
    var eq2 = Data_Eq.eq(Restaumatic_Form_Value.eqValue(dictEq));
    return {
        eq: function (x) {
            return function (y) {
                return eq(x.value0)(y.value0) && eq1(x.value1)(y.value1) && eq2(x.value2)(y.value2);
            };
        }
    };
};
var applyResult = {
    apply: function (v) {
        return function (v1) {
            return new Result(append(v.value0)(v1.value0), append1(v.value1)(v1.value1), apply(v.value2)(v1.value2));
        };
    },
    Functor0: function () {
        return functorResult;
    }
};
var lift2 = /* #__PURE__ */ Control_Apply.lift2(applyResult);
var semigroupResult = function (dictSemigroup) {
    return {
        append: lift2(Data_Semigroup.append(dictSemigroup))
    };
};
var applicativeResult = {
    pure: function (x) {
        return new Result(mempty, mempty1, pure(x));
    },
    Apply0: function () {
        return applyResult;
    }
};
var pure4 = /* #__PURE__ */ Control_Applicative.pure(applicativeResult);
var heytingAlgebraResult = function (dictHeytingAlgebra) {
    return {
        ff: pure4(Data_HeytingAlgebra.ff(dictHeytingAlgebra)),
        tt: pure4(Data_HeytingAlgebra.tt(dictHeytingAlgebra)),
        implies: lift2(Data_HeytingAlgebra.implies(dictHeytingAlgebra)),
        conj: lift2(Data_HeytingAlgebra.conj(dictHeytingAlgebra)),
        disj: lift2(Data_HeytingAlgebra.disj(dictHeytingAlgebra)),
        not: map1(Data_HeytingAlgebra.not(dictHeytingAlgebra))
    };
};
var monoidResult = function (dictMonoid) {
    var semigroupResult1 = semigroupResult(dictMonoid.Semigroup0());
    return {
        mempty: pure4(Data_Monoid.mempty(dictMonoid)),
        Semigroup0: function () {
            return semigroupResult1;
        }
    };
};
var additiveResult = function (dictAdditive) {
    return {
        zero: pure4(Data_Numeric.zero(dictAdditive)),
        add: lift2(Data_Numeric.add(dictAdditive)),
        sub: lift2(Data_Numeric.sub(dictAdditive))
    };
};
var value = function (v) {
    return v.value2;
};
var unsafeStrenghten = Unsafe_Coerce.unsafeCoerce;
var unsafeInvalid = function (e) {
    return new Result(mempty, e, Restaumatic_Form_Value.unsafeNoValue);
};
var toVLax = function (v) {
    if (v.value2 instanceof Restaumatic_Form_Value.SomeValue) {
        return pure1(v.value2.value0);
    };
    return Data_Validation_Semigroup.invalid(v.value1);
};
var toV = function (v) {
    if (v.value2 instanceof Restaumatic_Form_Value.SomeValue && Restaumatic_Form_Errors.isEmpty(v.value1)) {
        return pure1(v.value2.value0);
    };
    return Data_Validation_Semigroup.invalid(v.value1);
};
var toTotal = function (v) {
    if (v.value2 instanceof Restaumatic_Form_Value.SomeValue) {
        return v.value2.value0;
    };
    if (v.value2 instanceof Restaumatic_Form_Value.NoValue) {
        return Partial_Unsafe.unsafeCrashWith("Expected a Total result, got no value, errors=" + show(fromFoldable(unwrap(v.value1))));
    };
    throw new Error("Failed pattern match at Restaumatic.Form.Result (line 139, column 1 - line 139, column 43): " + [ v.constructor.name ]);
};
var toStrictWithLoading = function (v) {
    if (v.value0 instanceof Data_Loading.Loaded && (v.value2 instanceof Restaumatic_Form_Value.SomeValue && Restaumatic_Form_Errors.isEmpty(v.value1))) {
        return pure2(v.value2.value0);
    };
    return Data_Validation_Semigroup.invalid(new Data_Loading.MkLoading(v.value0, v.value1));
};
var toMaybeLax = function (v) {
    if (v.value2 instanceof Restaumatic_Form_Value.SomeValue) {
        return pure3(v.value2.value0);
    };
    return Data_Maybe.Nothing.value;
};
var toMaybe = function (v) {
    if (v.value2 instanceof Restaumatic_Form_Value.SomeValue && Restaumatic_Form_Errors.isEmpty(v.value1)) {
        return pure3(v.value2.value0);
    };
    return Data_Maybe.Nothing.value;
};
var relax = function () {
    return Unsafe_Coerce.unsafeCoerce;
};
var relax1 = /* #__PURE__ */ relax();
var toStrict = function (v) {
    if (v.value2 instanceof Restaumatic_Form_Value.SomeValue && not(Restaumatic_Form_Errors.isEmpty)(v.value1)) {
        return new Result(v.value0, v.value1, Restaumatic_Form_Value.noValue);
    };
    return relax1(v);
};
var orElse = function (v) {
    return function (fallback) {
        return new Result(v.value0, v.value1, Restaumatic_Form_Value.orElse(v.value2)(pure(fallback)));
    };
};
var mapErrors = function (f) {
    return function (v) {
        return new Result(v.value0, f(v.value1), v.value2);
    };
};
var loadingStatus = function (v) {
    return v.value0;
};
var loading = /* #__PURE__ */ (function () {
    return new Result(Data_Loading.Loading.value, mempty1, Restaumatic_Form_Value.noValue);
})();
var liftMaybe = function (v) {
    if (v instanceof Data_Maybe.Nothing) {
        return new Result(mempty, Restaumatic_Form_Errors.unknownError, Restaumatic_Form_Value.noValue);
    };
    if (v instanceof Data_Maybe.Just) {
        return pure4(v.value0);
    };
    throw new Error("Failed pattern match at Restaumatic.Form.Result (line 82, column 1 - line 82, column 53): " + [ v.constructor.name ]);
};
var invalidPrf = function (prf) {
    return function (e) {
        return new Result(mempty, e, new Restaumatic_Form_Value.NoValue(prf));
    };
};
var invalid = /* #__PURE__ */ invalidPrf(Restaumatic_Form_Totality.isPartial);
var liftV = /* #__PURE__ */ Data_Validation_Semigroup.validation(invalid)(pure4);
var getErrors = function (v) {
    return Restaumatic_Form_Errors.formErrorsToArray(v.value1);
};
var errors = function (v) {
    return v.value1;
};
var andThenA = function (dictApplicative) {
    var pure5 = Control_Applicative.pure(dictApplicative);
    var map2 = Data_Functor.map((dictApplicative.Apply0()).Functor0());
    return function (v) {
        return function (v1) {
            if (v.value2 instanceof Restaumatic_Form_Value.NoValue) {
                return pure5(new Result(v.value0, v.value1, new Restaumatic_Form_Value.NoValue(v.value2.value0)));
            };
            if (v.value2 instanceof Restaumatic_Form_Value.SomeValue) {
                return map2(function (v2) {
                    return new Result(append(v.value0)(v2.value0), append1(v.value1)(v2.value1), v2.value2);
                })(v1(v.value2.value0));
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Result (line 58, column 1 - line 58, column 99): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var andThen = function (v) {
    return function (v1) {
        if (v.value2 instanceof Restaumatic_Form_Value.NoValue) {
            return new Result(v.value0, v.value1, new Restaumatic_Form_Value.NoValue(v.value2.value0));
        };
        if (v.value2 instanceof Restaumatic_Form_Value.SomeValue) {
            var v2 = v1(v.value2.value0);
            return new Result(append(v.value0)(v2.value0), append1(v.value1)(v2.value1), v2.value2);
        };
        throw new Error("Failed pattern match at Restaumatic.Form.Result (line 49, column 1 - line 49, column 71): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
export {
    Result,
    andThen,
    andThenA,
    orElse,
    liftMaybe,
    liftV,
    invalid,
    loading,
    unsafeInvalid,
    invalidPrf,
    errors,
    getErrors,
    mapErrors,
    loadingStatus,
    toStrict,
    toV,
    toVLax,
    toMaybe,
    toMaybeLax,
    toStrictWithLoading,
    toTotal,
    value,
    relax,
    unsafeStrenghten,
    eqResult,
    functorResult,
    applyResult,
    applicativeResult,
    heytingAlgebraResult,
    genericResult_,
    showResult,
    semigroupResult,
    monoidResult,
    additiveResult,
    hasFieldResultResult
};
